import React from "react";
import Translate from '../../common/functions/translate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrashAlt, faClone, faEye, faCloudUploadAlt, faCalculator } from '@fortawesome/free-solid-svg-icons';
import { OfferGridModel } from "../../models/offer/offerGridModel";
import Button from "@material-ui/core/Button";
import ConfirmDialog from '../../common/components/confirmDialog/confirmDialog';
import Spinner from "../../common/components/spinner/spinner";
import Snackbar from "../../common/components/snackbar/snackbar";
import OffersService from "../../services/offersService";
import AuthService from "../../services/authService";
import { OfferFilterSettingsModel } from "../../models/offer/offerFilterSettingsModel";
import * as HelperFunctions from '../../common/functions/helperFunctions';
import LocalOffersService from "../../services/localDataServices/localOffersService";
import { OfferStatus, TimePeriod } from "../../common/enums";
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import FilterListIcon from '@material-ui/icons/FilterList';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import OfferFilter from './offerFilter';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import blue from '@material-ui/core/colors/blue';
import green from '@material-ui/core/colors/green';
import SynchronizationService from "../../services/synchronizationService";
import LocalProductsService from "../../services/localDataServices/localProductsService";
import { IProduct } from "../../common/appDatabase";
import { ProductLiteModel } from "../../models/product/productLiteModel";
import GeneratePDFService from "../../services/generatePdfFromBase";
import { FileModel } from "../../models/fileModel";
import GenerateXlxsService from "../../services/generateXlsxService";
import { OfferFilterDataModel } from "../../models/offer/offerFilterDataModel";

const theme = createMuiTheme({
    overrides: {
    },
    palette: {
        primary: blue
    },
});

const themeGreen = createMuiTheme({
    palette: {
        primary: green,
    },
});

interface IProps {
    history: any;
}

interface IState {
    isLoading: boolean;
    offers: Array<OfferGridModel>;
    isVisibleConfirmDialog: boolean;
    currentOffer: OfferGridModel;
    from: number;
    numberOfRows: number;
    currentPage: number;
    totalRecordsCount: number;
    offerSettings: OfferFilterSettingsModel;
    isVisibleFilterDialog: boolean;
    isVisibleFilterDialogWrap: boolean;
    filterSettings: OfferFilterSettingsModel;
    isFiltering: boolean;
    spinnerTxt: string;
    notSentOffersCount: number;

}

const initFrom = 0;
const numberOfRows = 10;

class OfferListComponent extends React.Component<IProps, IState>{

    offerService = new OffersService();
    authService = new AuthService();
    snackbar: any;
    localOffersService = new LocalOffersService();
    synchronizationService = new SynchronizationService();
    localProductsService = new LocalProductsService();
    generatePDFService = new GeneratePDFService();
    generateXlxsService = new GenerateXlxsService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            isLoading: false,
            offers: new Array<OfferGridModel>(0),
            isVisibleConfirmDialog: false,
            currentOffer: new OfferGridModel(),
            from: initFrom,
            numberOfRows: numberOfRows,
            totalRecordsCount: this.getRemoteOffersCount(),
            offerSettings: new OfferFilterSettingsModel(),
            isVisibleFilterDialog: false,
            isVisibleFilterDialogWrap: false,
            filterSettings: new OfferFilterSettingsModel(),
            currentPage: 0,
            isFiltering: false,
            spinnerTxt: '',
            notSentOffersCount: 0
        }
    }

    componentDidMount() {
        this.localOffersService.getOffersWithNoRemoteIdCount().then(
            (count: any) => {
                let offerFilterData = this.getOfferFilterData();

                if (offerFilterData) {
                    this.setState({
                        notSentOffersCount: count ? count : 0,
                        filterSettings: offerFilterData.filterSettings ? offerFilterData.filterSettings : this.state.filterSettings,
                        from: offerFilterData.from ? offerFilterData.from : this.state.from,
                        numberOfRows: offerFilterData.numberOfRows ? offerFilterData.numberOfRows : this.state.numberOfRows,
                        currentPage: offerFilterData.currentPage ? offerFilterData.currentPage : this.state.currentPage,
                        isFiltering: offerFilterData.filterSettings ? true : false
                    }, () => this.getAllOffers(true))
                } else {
                    this.setState({ notSentOffersCount: count ? count : 0 }, () => this.getAllOffers(true))
                }
            }
        ).catch(error => {
            let offerFilterData = this.getOfferFilterData();

            if (offerFilterData) {
                this.setState({
                    filterSettings: offerFilterData.filterSettings ? offerFilterData.filterSettings : this.state.filterSettings,
                    from: offerFilterData.from ? offerFilterData.from : this.state.from,
                    numberOfRows: offerFilterData.numberOfRows ? offerFilterData.numberOfRows : this.state.numberOfRows,
                    currentPage: offerFilterData.currentPage ? offerFilterData.currentPage : this.state.currentPage,
                    isFiltering: offerFilterData.filterSettings ? true : false
                }, () => this.getAllOffers(true))
            } else {
                this.getAllOffers(true);
            }
        });

        //this.initializeFilter();
    }

    getOfferFilterData = (): OfferFilterDataModel | null => {
        let offerFilterData = sessionStorage.getItem('offerFilterData');

        if (offerFilterData) {
            return JSON.parse(offerFilterData) as OfferFilterDataModel;
        } else {
            return null;
        }
    }

    initializeFilter = () => {
        let filterSettings = { ...this.state.filterSettings };

        let endDate = new Date();
        let startDate = new Date();
        let yearEarlier = startDate.setFullYear(startDate.getFullYear() - 1);
        filterSettings.endDate = HelperFunctions.fomatDateAsString(endDate);
        filterSettings.startDate = HelperFunctions.fomatDateAsString(new Date(yearEarlier));
        filterSettings.timePeriodId = TimePeriod.Year;

        this.setState({
            filterSettings
        });
    }

    showFilterDialog = (show: boolean) => {
        this.setState({
            isVisibleFilterDialogWrap: show
        });
        setTimeout(() => this.setState({
            isVisibleFilterDialog: show
        }));
    }

    handleCloseFilterModal = () => {
        this.showFilterDialog(false);
    }

    getAllOffers(isInitial: boolean) {
        this.setState({
            isLoading: true
        });

        let filterSettings = { ...this.state.filterSettings };
        let isFiltering = this.state.isFiltering;

        let from = this.state.from;
        let numberOfRows = this.state.numberOfRows;
        let notSentOffersCount = this.state.notSentOffersCount;
        let currentPage = this.state.currentPage;
        let remoteOffersCount = this.getRemoteOffersCount();

        if (isFiltering) {
            let offerFilterData = new OfferFilterDataModel();
            offerFilterData.filterSettings = filterSettings;
            offerFilterData.from = from;
            offerFilterData.numberOfRows = numberOfRows;
            offerFilterData.currentPage = currentPage;

            sessionStorage.setItem('offerFilterData', JSON.stringify(offerFilterData));
        } else {
            let offerFilterData = new OfferFilterDataModel();
            offerFilterData.from = from;
            offerFilterData.numberOfRows = numberOfRows;
            offerFilterData.currentPage = currentPage;

            sessionStorage.setItem('offerFilterData', JSON.stringify(offerFilterData));
        }

        if (filterSettings.number) {
            filterSettings.number = filterSettings.number.trim();
        }

        if (filterSettings.client) {
            filterSettings.client = filterSettings.client.trim();
        }

        if (!isInitial) {
            this.localOffersService.getOffersWithRemoteIdCount().then(
                (dbOffersCount: any) => {
                    if ((isFiltering && dbOffersCount < remoteOffersCount) || (!isFiltering && (dbOffersCount < remoteOffersCount && dbOffersCount < (from + numberOfRows)))) {
                        this.setState({ spinnerTxt: Translate('Synchronization please wait') });

                        this.localOffersService.getOffersRemoteIds().then(
                            (offersRemoteIds: any) => {
                                filterSettings.loadedOffers = offersRemoteIds;

                                if (navigator.onLine) {
                                    // call API
                                    this.offerService.getAllOffers(from, numberOfRows, filterSettings).then(
                                        (data: any) => {
                                            if (data.offers && data.offers.length > 0) {
                                                this.localOffersService.addOffersToLocalDb(data.offers).then(
                                                    () => {
                                                        let totalRecords = data.offersCount;

                                                        if (!isFiltering) {
                                                            totalRecords += notSentOffersCount
                                                        }

                                                        this.setState({
                                                            totalRecordsCount: totalRecords
                                                        }, () => this.getOffersFromLocalDb(from, numberOfRows, filterSettings, true));
                                                    }
                                                )
                                            } else {
                                                let totalRecords = data.offersCount;

                                                if (!isFiltering) {
                                                    totalRecords += notSentOffersCount
                                                }

                                                this.setState({
                                                    totalRecordsCount: totalRecords
                                                }, () => this.getOffersFromLocalDb(from, numberOfRows, filterSettings, true));
                                            }
                                        }
                                    ).catch(error => {
                                        this.setState({ isLoading: false });
                                        console.log(error);
                                        this.snackbar.show({ severity: 'warning', summary: Translate('Problem getting data from server. You see only local offers.') });
                                        this.getOffersFromLocalDb(from, numberOfRows, filterSettings, true);
                                    })
                                } else {
                                    this.snackbar.show({ severity: 'warning', summary: Translate('No connection with server. You see only local offers') });
                                    //this.getOffersFromLocalDb(from, numberOfRows, filterSettings);
                                }
                            }
                        ).catch(error => {
                            console.log(error);
                            this.setState({ isLoading: false });
                            this.snackbar.show({ severity: 'warning', summary: Translate('Problem getting data from server. You see only local offers.') });
                        });
                    } else {
                        this.getOffersFromLocalDb(from, numberOfRows, filterSettings);
                    }
                }
            ).catch(error => {
                console.log(error);
                this.setState({ isLoading: false });
                this.snackbar.show({ severity: 'warning', summary: Translate('Problem getting data from server. You see only local offers.') });
            });
        } else {
            this.getOffersFromLocalDb(from, numberOfRows, filterSettings)
        }
    }

    getOffersFromLocalDb = (from: number, numberOfRows: number, filterSettings: OfferFilterSettingsModel, isAfterAPICall: boolean = false) => {
        this.localOffersService.getOffers(from, numberOfRows, filterSettings).then(
            (result: any) => {
                let totalRecordsCount = this.state.totalRecordsCount;
                let isFiltering = this.state.isFiltering;
                let notSentOffersCount = this.state.notSentOffersCount;

                if (!isAfterAPICall) {
                    totalRecordsCount = this.getRemoteOffersCount() + notSentOffersCount;

                    if (isFiltering) {
                        totalRecordsCount = result.count;
                    }
                } else {
                    if (isFiltering) {
                        totalRecordsCount += result.notSentCount;
                    }
                }

                this.setState({
                    isLoading: false,
                    spinnerTxt: '',
                    from: from,
                    offers: result.offers,
                    totalRecordsCount
                });
            }).catch(error => {
                console.log(error);
                this.snackbar.show({ severity: 'error', summary: Translate(error) });
                this.setState({
                    isLoading: false,
                    spinnerTxt: '',
                });
            });
    }

    handleDeleteClick = (e, offer: OfferGridModel) => {
        e.stopPropagation();

        if (offer.remoteId && offer.offerStatusId !== OfferStatus.NewOffer) {
            this.snackbar.show({ severity: 'error', summary: Translate('Cannot delete offer, offer is already sent') });
            return;
        }

        this.setState({
            isVisibleConfirmDialog: true,
            currentOffer: offer
        });
    };

    deleteOffer(id, remoteId) {
        this.setState({
            isVisibleConfirmDialog: false,
            isLoading: true
        });

        this.localOffersService.deleteOffer(id).then(
            data => {
                if (!remoteId) {
                    let notSentOffersCount = this.state.notSentOffersCount;
                    notSentOffersCount--;

                    this.setState({
                        notSentOffersCount: notSentOffersCount < 0 ? 0 : notSentOffersCount
                    });
                }

                // offer is reported => delete it from server
                if (remoteId !== 0) {
                    if (navigator.onLine) {
                        let offerIds = new Array<number>();
                        offerIds.push(remoteId);

                        // delete from server
                        this.synchronizationService.deleteOffers(offerIds).then(
                            () => {
                                this.localOffersService.decrementServerOffersCount();
                                let totalRecordsCount = this.state.totalRecordsCount;

                                totalRecordsCount -= 1;
                                this.snackbar.show({ severity: 'success', summary: Translate('Offer deleted successfully') });

                                this.setState({
                                    isLoading: false,
                                    totalRecordsCount: totalRecordsCount < 0 ? 0 : totalRecordsCount
                                }, () => this.getAllOffers(true));

                            }).catch(error => {
                                this.setState({ isLoading: false });
                                console.log(error);
                                this.snackbar.show({ severity: 'error', summary: Translate('Problem deleting offer on server') });
                            })
                    } else {
                        // add offer for deletion
                        this.localOffersService.addOfferForDeletion(remoteId).then(() => {
                        }).catch(error => {
                            this.setState({ isLoading: false });
                            console.log(error);
                            this.snackbar.show({ severity: 'error', summary: Translate(error) });
                        })

                        this.snackbar.show({ severity: 'success', summary: Translate('Offer deleted successfully') });
                        this.getAllOffers(true);
                        this.setState({
                            isLoading: false
                        });
                    }
                } else {
                    this.snackbar.show({ severity: 'success', summary: Translate('Offer deleted successfully') });
                    this.getAllOffers(true);
                    this.setState({
                        isLoading: false
                    });
                }

            }).catch(error => {
                this.snackbar.show({ severity: 'error', summary: Translate(error) });
                this.setState({
                    isLoading: false
                });
            });
    }

    handleAddClick = () => {
        this.props.history.push('/offers/0');
    }

    filterClick = () => {
        this.showFilterDialog(true);
    }

    getFilterSummary = () => {
        const { filterSettings } = this.state;

        if (!filterSettings.client && !filterSettings.endDate && !filterSettings.number && !filterSettings.startDate
            && !filterSettings.statusId && !filterSettings.timePeriodId) {
            return;
        }

        let statusSet: any = null;
        let numberSet: any = null;
        let clientSet: any = null;
        let periodSet: any = null;

        if (filterSettings && filterSettings.statusId) {
            let statuses = HelperFunctions.enumToDropdownArray(OfferStatus, true);
            statusSet =
                <>
                    <span style={{ color: '#999' }}>{Translate('Status')}</span>:
                    <span style={{ fontWeight: 600 }}> {statuses[filterSettings.statusId - 1].label} </span>
                </>
        }

        if (filterSettings && filterSettings.number) {
            numberSet =
                <>
                    <span style={{ color: '#999' }}>{Translate('Number')}</span>:
                    <span style={{ fontWeight: 600 }}> {filterSettings.number} </span>
                </>
        }

        if (filterSettings && filterSettings.client) {
            clientSet =
                <>
                    <span style={{ color: '#999' }}>{Translate('Client')}</span>:
                    <span style={{ fontWeight: 600 }}> {filterSettings.client} </span>
                </>
        }

        if (filterSettings && (filterSettings.startDate || filterSettings.endDate)) {
            periodSet =
                <>
                    {filterSettings.startDate ?
                        <>
                            <span style={{ color: '#999' }}>{Translate('From')}</span>:
                            <span style={{ fontWeight: 600 }}> {HelperFunctions.fomatDatesStringWithLang(new Date(filterSettings.startDate))} </span>
                        </>
                        : null}
                    {filterSettings.endDate ?
                        <>
                            <span style={{ color: '#999' }}>{Translate('To')}</span>:
                            <span style={{ fontWeight: 600 }}> {HelperFunctions.fomatDatesStringWithLang(new Date(filterSettings.endDate))} </span>
                        </>
                        : null}
                </>
        }

        let summary =
            <div style={{ fontSize: '0.95em' }}>

                <p style={{ marginTop: 0, marginBottom: 5 }}>
                    <span style={{ fontWeight: 600 }}>{Translate("Filters")}: </span>
                    {statusSet}
                    {numberSet}
                    {clientSet}
                    {periodSet}
                </p>
                <div style={{ marginBottom: 10 }}>
                    <Button color="primary" variant="contained" onClick={this.clearFilters} size="small">
                        {Translate('View all')}
                    </Button>
                    {/* <span style={{ color: '#2196f3', cursor: 'pointer' }} onClick={this.clearFilters}>
                        {Translate('View all')}
                    </span> */}
                </div>
            </div>


        return summary;
    }

    handleChangePage = (event: any, page: number) => {
        this.setState({
            currentPage: page,
            from: page * this.state.numberOfRows
        }, () => this.getAllOffers(false));
    }

    handleChangeRowsPerPage = (event: any) => {
        this.setState({
            currentPage: 0,
            from: 0,
            numberOfRows: event.target.value,
        }, () => this.getAllOffers(false))
    }

    doFilter = (filterSettings: OfferFilterSettingsModel) => {
        this.showFilterDialog(false);

        const { numberOfRows } = this.state;

        this.setState({
            offers: [],
            from: 0,
            currentPage: 0,
            filterSettings,
            numberOfRows,
            isFiltering: true,
        }, () => this.getAllOffers(false))

    }

    clearFilters = () => {
        //this.showFilterDialog(false);

        let filterSettings = new OfferFilterSettingsModel();

        sessionStorage.removeItem('offerFilterData');

        // let endDate = new Date();
        // let startDate = new Date();
        // let yearEarlier = startDate.setFullYear(startDate.getFullYear() - 1);
        // filterSettings.endDate = HelperFunctions.fomatDateAsString(endDate);
        // filterSettings.startDate = HelperFunctions.fomatDateAsString(new Date(yearEarlier));
        // filterSettings.timePeriodId = TimePeriod.Year;

        const { numberOfRows } = this.state;

        this.setState({
            filterSettings,
            from: 0,
            currentPage: 0,
            numberOfRows,
            isFiltering: false
        }, () => this.getAllOffers(true));
    }

    cloneTwoDimPlan = (e, offerId: number) => {
        e.stopPropagation();
        this.setState({ isLoading: true });
        this.localOffersService.getOffer(offerId).then(
            (res: any) => {
                if (!res || !res.planner || res.planner === '') {
                    this.snackbar.show({ severity: 'warning', summary: Translate('NoTwoDimPlan') });
                    this.setState({
                        isLoading: false
                    });
                }
                else {
                    let layerForCopy = JSON.stringify(res.planner.layers['layer-1']);
                    let width = JSON.stringify(res.planner.width);
                    let height = JSON.stringify(res.planner.height);
                    let copyPlanner = { copiedLayer: layerForCopy, copiedWidth: width, copiedHeight: height }
                    localStorage.setItem('copyPlanner', JSON.stringify(copyPlanner));
                    this.props.history.push({ pathname: `/offers/0`, search: '?copiedLayer=true' })
                }
            }).catch(error => {
                this.snackbar.show({ severity: "error", summary: Translate(error) });
                this.setState({
                    isLoading: false
                });
            });
    }

    handleSynchroBtnClick = (e, offerId) => {
        e.stopPropagation();

        if (!navigator.onLine) {
            this.snackbar.show({ severity: "error", summary: Translate('Report offer no network connection') });
            return;
        }

        this.setState({
            isLoading: true,
            spinnerTxt: Translate('Synchronization please wait')
        });

        let notSentOffersCount = this.state.notSentOffersCount;

        this.localOffersService.getOfferForSynchronization(+offerId).then(
            (syncOffer: any) => {
                if (syncOffer) {
                    this.synchronizationService.reportOffer(syncOffer).then(
                        (reportedOffer) => {
                            if (reportedOffer) {
                                this.localOffersService.updateOfferAfterSynchronization(reportedOffer).then(
                                    () => {
                                        this.setState({
                                            isLoading: false,
                                            spinnerTxt: '',
                                        });

                                        if (!syncOffer.id) {
                                            this.localOffersService.incrementServerOffersCount();
                                            notSentOffersCount--;
                                        }

                                        this.setState({ notSentOffersCount }, () => this.getAllOffers(true));

                                        this.snackbar.show({ severity: 'success', summary: Translate('Data Saved Successfully Server') });

                                    }).catch(error => {
                                        this.setState({
                                            isLoading: false,
                                            spinnerTxt: ''
                                        });
                                        this.snackbar.show({ severity: "error", summary: Translate(error) });
                                    })
                            } else {
                                this.setState({
                                    isLoading: false,
                                    spinnerTxt: ''
                                });
                            }
                        }).catch(error => {
                            this.setState({
                                isLoading: false,
                                spinnerTxt: ''
                            });
                            this.snackbar.show({ severity: "error", summary: Translate(error) });
                        })
                } else {
                    this.setState({
                        isLoading: false,
                        spinnerTxt: ''
                    });
                }
            }).catch(error => {
                this.setState({
                    isLoading: false,
                    spinnerTxt: '',
                });
                this.snackbar.show({ severity: "error", summary: Translate(error) });
            })
    }


    createFile = (installationPdf, pdfFile, title, currentDate) => {
        let newFile = installationPdf
        if (!newFile)
            newFile = new FileModel();

        newFile.fileContent = pdfFile;
        newFile.fileSizeInBytes = Math.round(pdfFile.length * 3 / 4);
        newFile.fileName = title;
        newFile.updatedOn = currentDate;
        return newFile
    }

    handleRecalculateBtnClick = (e, offerId) => {
        e.stopPropagation();

        this.setState({
            isLoading: true
        });

        this.localProductsService.getAllProducts().then(
            (dbProducts: any) => {
                this.localOffersService.getOffer(+offerId).then(
                    (offer: any) => {
                        if (offer && dbProducts) {
                            this.setState({
                                isLoading: false
                            });

                            if (offer.gasInstallation && offer.gasInstallation.products) {
                                this.recalculateProducts(offer.gasInstallation.products, dbProducts)
                            }

                            if (offer.gasInstallation && offer.gasInstallation.additionalProducts) {
                                this.recalculateProducts(offer.gasInstallation.additionalProducts, dbProducts)
                            }

                            if (offer.heathInstall && offer.heathInstall.products) {
                                this.recalculateProducts(offer.heathInstall.products, dbProducts)
                            }

                            if (offer.heathInstall && offer.heathInstall.additionalProducts) {
                                this.recalculateProducts(offer.heathInstall.additionalProducts, dbProducts)
                            }

                            let currentDate = HelperFunctions.fomatDateTimeAsString(new Date());

                            offer.updatedOn = currentDate;

                            let totalAmount = 0;
                            if (offer.gasInstallation && offer.gasInstallation.products) {
                                totalAmount += HelperFunctions.calculateProductsPrice(offer.gasInstallation.products);
                            }

                            if (offer.heathInstall && offer.heathInstall.products) {
                                totalAmount += HelperFunctions.calculateProductsPrice(offer.heathInstall.products);
                            }

                            if (offer.gasInstallation && offer.gasInstallation.additionalProducts) {
                                totalAmount += HelperFunctions.calculateProductsPrice(offer.gasInstallation.additionalProducts);
                            }

                            if (offer.heathInstall && offer.heathInstall.additionalProducts) {
                                totalAmount += HelperFunctions.calculateProductsPrice(offer.heathInstall.additionalProducts);
                            }
                            offer.price = totalAmount;

                            let traderName = this.authService.getUserName();
                            let traderPhone = this.authService.getUserPhone();
                            if (offer.trader && offer.trader.userId) {
                                traderName = offer.trader.name;
                                traderPhone = offer.trader.phone;
                            }

                            let content = this.generatePDFService.getOfferContent(offer, totalAmount, traderName, traderPhone)

                            offer.priceChanged = false;
                            offer.reported = false;

                            this.setState({
                                isLoading: true
                            });

                            this.generatePDFService.createPDFDocument(offer, content).then((pdf: any) => {

                                offer.offerPdf = this.createFile(offer.offerPdf, pdf, (Translate('Offer') + " - " + offer.offerNumber), currentDate);

                                this.generateXlxsService.generateBillOfQuantities(offer).then(
                                    (billOfQuantitiesResult: any) => {
                                        if (billOfQuantitiesResult.devicesAndMaterials) {
                                            offer.billOfQuantitiesExcel = this.createFile(offer.billOfQuantitiesExcel, billOfQuantitiesResult.devicesAndMaterials, Translate('Bill of quantities') + ' - ' + offer.offerNumber, currentDate);
                                        } else {
                                            offer.billOfQuantitiesExcel = new FileModel();
                                        }

                                        if (billOfQuantitiesResult.labor) {
                                            offer.billOfQuantitiesLaborExcel = this.createFile(offer.billOfQuantitiesLaborExcel, billOfQuantitiesResult.labor, Translate('Bill of quantities labor') + ' - ' + offer.offerNumber, currentDate);
                                        } else {
                                            offer.billOfQuantitiesLaborExcel = new FileModel();
                                        }

                                        this.localOffersService.updateOffer(offer).then(
                                            () => {
                                                this.setState({
                                                    isLoading: false,
                                                });

                                                this.snackbar.show({ severity: 'success', summary: Translate('Offer recalculation succesfull') });
                                                this.getAllOffers(true);
                                            })
                                            .catch(error => {
                                                this.setState({
                                                    isLoading: false
                                                });
                                                this.snackbar.show({ severity: "error", summary: Translate(error) });
                                            })
                                    }
                                )
                            });
                        }
                    }).catch(error => {
                        console.log(error);
                        this.snackbar.show({ severity: "error", summary: Translate(error) });
                    })
            }).catch(error => {
                console.log(error);
                this.snackbar.show({ severity: "error", summary: Translate('Problem recalculating offer') })
            })

    }

    recalculateProducts = (products: Array<ProductLiteModel>, dbProducts: Array<IProduct>) => {
        if (products) {
            products.forEach(product => {
                let dbProduct = dbProducts.find(p => p.remoteId === product.productId);

                if (dbProduct) {
                    product.price = dbProduct.price;
                    product.priceWithoutDiscount = dbProduct.price;
                    product.discount = dbProduct.discount;
                    product.article = dbProduct.article;
                    product.articleNumber = dbProduct.articleNumber;

                    if (dbProduct.discount > 0) {
                        product.price = dbProduct.price - (dbProduct.price * dbProduct.discount / 100);
                    }
                }
            })
        }
    }

    getPageStart = (pageSize: number, pageNumber: number) => {
        return pageSize * pageNumber;
    }

    getPageStartEnd = (total: number, pageSize: number, pageNumber: number): Array<number> => {
        const start = Math.max(
            this.getPageStart(pageSize, pageNumber),
            0
        );
        const end = Math.min(
            this.getPageStart(pageSize, pageNumber + 1),
            total
        );

        let result = new Array<number>(0);
        result.push(start + 1);
        result.push(end);

        return result;
    }

    render() {
        const { offers, isLoading, isVisibleConfirmDialog, isVisibleFilterDialog, isVisibleFilterDialogWrap,
            filterSettings, totalRecordsCount, currentPage, numberOfRows, spinnerTxt } = this.state;

        const pageStartEnd = this.getPageStartEnd(this.state.totalRecordsCount, this.state.numberOfRows, this.state.currentPage);

        return (
            <div className="app-page-content">
                {isLoading ? <Spinner text={spinnerTxt} /> : null}

                <Snackbar ref={(el) => this.snackbar = el} />

                <h1>{Translate("Offers")}</h1>
                {/* <div style={{ display: "flex" }}>
                    <div className="header-button new-offer">
                        <div style={{ marginRight: 10 }}>
                            <div>{Translate("Creating")}</div>
                            <div className="detail">{Translate("new offer")}</div>
                        </div>
                        <div><AddIcon /></div>
                    </div>
                    <div className="header-button existing-offer">
                        <div style={{ marginRight: 10 }}>
                            <div>{Translate("Opening")}</div>
                            <div className="detail">{Translate("existing offer")}</div>
                        </div>
                        <div><FilterListIcon /></div>
                    </div>
                </div> */}
                <Fab color="primary" aria-label="Add" size="small" onClick={() => this.handleAddClick()} className="floating-action-button">
                    <AddIcon />
                </Fab>
                <Fab color="primary" focusRipple={false} aria-label="Search" size="small" onClick={() => this.filterClick()} className="floating-action-button-second">
                    <FilterListIcon />
                </Fab>
                <div>
                    {this.state.isFiltering ? this.getFilterSummary() : null}
                </div>
                {!isLoading && offers && offers.length > 0 ?
                    <div className="list-items-count-info">
                        {pageStartEnd
                            ? <>
                                {Translate('Showing from')} <span className='list-items-count-info-number'>{pageStartEnd[0]}</span> {Translate('to')} <span className='list-items-count-info-number'>{pageStartEnd[1]}</span> {Translate('from')} {' '}
                            </>
                            : null}
                        <span className='list-items-count-info-number'>{totalRecordsCount}</span> {Translate('total records.')}
                    </div> : null}

                {offers && offers.length > 0
                    ?
                    <MuiThemeProvider theme={theme}>
                        <Paper >
                            <TableContainer>
                                <Table style={{ minWidth: 900 }} stickyHeader size="small" >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ width: 150 }}><strong>{Translate("Number")}</strong></TableCell>
                                            <TableCell><strong>{Translate("Date")}</strong></TableCell>
                                            {this.authService.checkIsRegionalManager() ?
                                                <TableCell><strong>{Translate("Trader")}</strong></TableCell> : null}
                                            <TableCell><strong>{Translate("Client")}</strong></TableCell>
                                            <TableCell><strong>{Translate("Status")}</strong></TableCell>
                                            <TableCell style={{ width: 150 }} align="right"><strong>{`${Translate("Price")} (${Translate('w/о VAT')})`}</strong></TableCell>
                                            <TableCell style={{ width: 250 }} align="center"><strong>{Translate("Actions")}</strong></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {offers.map((m: OfferGridModel) =>
                                            <TableRow hover onClick={() => this.props.history.push(`/offers/${m.id}`)} key={m.id} >
                                                <TableCell style={{ width: 130 }}>{m.offerNumber}</TableCell>
                                                <TableCell style={{ width: 130 }}>{HelperFunctions.fomatDatesStringWithLang(new Date(m.offerDate))}</TableCell>
                                                {this.authService.checkIsRegionalManager() ? <TableCell>{m.traderName}</TableCell> : null}
                                                <TableCell>
                                                    {m.clientName ? m.clientName : ""}
                                                    {m.clientTown ? ", " + m.clientTown : ""}
                                                    {m.clientAddress ? ", " + m.clientAddress : ""}
                                                </TableCell>
                                                <TableCell style={{ width: 150 }}>
                                                    <div style={HelperFunctions.getOfferStatusColor(m.offerStatusId)}>
                                                        {HelperFunctions.getEnumLabel(m.offerStatusId, OfferStatus, true)}
                                                    </div>
                                                </TableCell>
                                                <TableCell style={{ width: 150 }} align="right">{m.offerPrice.toFixed(2) + " " + Translate("BGN")}</TableCell>
                                                <TableCell style={{ width: 200 }} align="left">
                                                    <MuiThemeProvider theme={themeGreen}>
                                                        <Button className="action-button" variant="contained" color='primary' onClick={(e) => this.cloneTwoDimPlan(e, m.id)} >
                                                            <FontAwesomeIcon icon={faClone} style={{ color: "#fff" }} />
                                                        </Button>
                                                    </MuiThemeProvider>
                                                    <Button className="action-button" variant="contained" color='primary' onClick={() => this.props.history.push(`/offers/${m.id}`)} >
                                                        <FontAwesomeIcon icon={m.offerStatusId === OfferStatus.NewOffer || m.offerStatusId === OfferStatus.Expired ||
                                                            m.offerStatusId === OfferStatus.SentToClient ? faPen : faEye} />
                                                    </Button>
                                                    {m.offerStatusId === OfferStatus.NewOffer ?
                                                        <Button className="action-button" variant="contained" color='secondary'
                                                            onClick={(e) => this.handleDeleteClick(e, m)} >
                                                            <FontAwesomeIcon icon={faTrashAlt} />
                                                        </Button> : null}
                                                    {!m.reported
                                                        ? <Button className="action-button" variant="contained" color='default' onClick={(e) => this.handleSynchroBtnClick(e, m.id)} >
                                                            <FontAwesomeIcon icon={faCloudUploadAlt} color={'#f50057'} />
                                                        </Button> : null}
                                                    {m.priceChanged
                                                        ? <Button className="action-button" variant="contained" color='default' onClick={(e) => this.handleRecalculateBtnClick(e, m.id)} >
                                                            <FontAwesomeIcon icon={faCalculator} color={'#2196F3'} style={{ fontSize: "17px" }} />
                                                        </Button> : null}

                                                </TableCell>
                                            </TableRow>
                                        )}

                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                rowsPerPageOptions={[10, 20]}
                                labelRowsPerPage=''
                                component="div"
                                count={totalRecordsCount}
                                rowsPerPage={numberOfRows}
                                page={currentPage}
                                onChangePage={(e, page) => this.handleChangePage(e, page)}
                                onChangeRowsPerPage={(e) => this.handleChangeRowsPerPage(e)}
                            />
                        </Paper>
                    </MuiThemeProvider>
                    : <div>
                        {Translate('No records found')}
                    </div>
                }

                {
                    this.state.isVisibleConfirmDialog ?
                        <ConfirmDialog
                            headerTitle={Translate("Confirm Dialog")}
                            isVisible={isVisibleConfirmDialog}
                            yesClick={() => { this.deleteOffer(this.state.currentOffer.id, this.state.currentOffer.remoteId) }}
                            noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
                            {Translate("Are you sure that you want to delete selected offer with ") +
                                Translate("Number") + ": " + this.state.currentOffer.offerNumber + ", " +
                                Translate("Date") + ": " + HelperFunctions.fomatDatesStringWithLang(new Date(this.state.currentOffer.offerDate)) +
                                "?"}
                        </ConfirmDialog>
                        : null
                }

                {
                    isVisibleFilterDialogWrap ? (
                        <OfferFilter
                            cancelClick={this.handleCloseFilterModal}
                            isVisible={isVisibleFilterDialog}
                            filterClick={this.doFilter}
                            filterSettings={filterSettings}
                            clearFilters={this.clearFilters} />
                    ) : null
                }
            </div >
        );
    }

    getRemoteOffersCount = (): number => {
        let count = 0;

        let offersCount = localStorage.getItem('offersCount');

        if (offersCount) {
            count = +offersCount;
        }

        return count;
    }
}

export default OfferListComponent;
